"use strict";
/**
 * 是否为空对象
 *
 * ### Example
 * ```
 * isEmptyObject({}); // => true
 * isEmptyObject({ a: 1 }) // => false
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}
exports.isEmptyObject = isEmptyObject;
